import {Link} from "react-router-dom";
import React from "react";

const Social = () => {
  const socialContent = [
    { id: 1, name : "Groupe Talents handicap sur Facebook", src : "icon-fb.svg", icon: "fa-facebook-f", link: "https://www.facebook.com/talents.handicap" },
    { id: 2, name : "Groupe Talents handicap sur X", src : "icon-X.svg", icon: "fa-x-twitter", link: "https://x.com/TalentsHandicap" },
    { id: 3, name : "Groupe Talents handicap sur Instagram", src : "icon-instagram.svg", icon: "fa-instagram", link: "https://www.instagram.com/talents.handicap" },
    { id: 4, name : "Groupe Talents handicap sur Linkedin", src : "icon-in.svg", icon: "fa-linkedin-in", link: "https://www.linkedin.com/company/talents-handicap/mycompany/" },
  ];
  return (
      <div className={'d-flex flex-row gap-3 mb-3'}>
      {socialContent.map((item) => (
        <Link key={item.id}
              to={item.link}
              title={item.name}
              target="_blank"
              rel="noopener noreferrer">
          <img src={`/images/icons/${item.src}`} alt={item.name} width={25} height={25}/>
        </Link>
      ))}
    </div>
  );
};

export default Social;
